/* GameEditorMessageComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./GameEditorMessageRenderer');
const _ = require('lodash');

class GameEditorMessageComponent extends EventEmitter {
  constructor(config) {
    super();
    this._renderer = new Renderer(this);

    this._icon = _.get(config, 'icon', undefined);
    this._action = _.get(config, 'action', undefined);
    this._message = _.get(config, 'message', undefined);

    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  _triggerAction(fqn) {
    this.emit('SelectAction', fqn);
  }
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  shutdown() {
    this._unregisterListeners();
    return this._renderer.shutdown().then(() => {
      this._renderer = undefined;
      this._icon = undefined;
      this._action = undefined;
      this._message = undefined;
    });
  }

  getIcon() {
    return this._icon;
  }
  setIcon(newIcon) {
    this._icon = newIcon;
    this.emit('Icon', this._icon);
    return this;
  }

  getAction() {
    return this._action;
  }
  setAction(newAction) {
    this._action = newAction;
    this.emit('Action', this._action);
    return this;
  }

  getMessage() {
    return this._message;
  }
  setMessage(newMessage) {
    this._message = newMessage;
    this.emit('Message', this._message);
    return this;
  }

  setDisplay(newVal) {
    this.setIcon(_.get(newVal, 'icon', undefined));
    this.setAction(_.get(newVal, 'action', undefined));
    this.setMessage(_.get(newVal, 'message', undefined));
    return this;
  }

  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = GameEditorMessageComponent;
